import { PurchaseItemStatus } from "common/src/models/PurchaseItem";
import { Dayjs } from "dayjs";
import { Amounts } from "./Amounts";
import { CancellationProtection } from "./CancellationProtection";
import { Coupon } from "./Coupon";
import { CouponCode } from "./CouponCode";
import { EquipmentUnit } from "./EquipmentUnit";
import { Form } from "./Form";
import { FormResponse } from "./FormResponse";
import { Guest } from "./Guest";
import { LineItem } from "./LineItem";
import { MembershipPurchaseItem } from "./MembershipPurchaseItem";
import { Organizer } from "./Organizer";
import { ProductReference } from "./Product";
// eslint-disable-next-line import/no-cycle
import { Purchase } from "./Purchase";
import { PurchaseItemObject } from "./PurchaseItemObject";
import { PurchaseItemReminder } from "./PurchaseItemReminder";
import { Source } from "./Source";
import { Ticket } from "./Ticket";
import { Waiver } from "./Waiver";
import { WeightUnit } from "./WeightUnit";
import { PartnerObject } from "./XolaPartner";

export enum PurchaseItemGuestStatus {
    PENDING = "pending",
    ARRIVED = "arrived",
    NO_SHOW = "noshow",
    RETURNED = "returned",
    PARTIALLY_ARRIVED = "partially_arrived",
}

export interface ExperiencePurchaseItem {
    id: ID;
    purchase: Purchase;
    status: PurchaseItemStatus;
    product: { id: ID };
    name: string;
    arrivalDateTime: Dayjs;
    arrivalDate: string;
    arrivalTime: number;
    arrivalTimezoneName: string;
    event: { id: ID };
    lineItems: LineItem[];
    privacy: PurchaseItemPrivacy;
    quantity: number;
    guests: Guest[];
    equipments?: EquipmentUnit[];
    guestStatus: PurchaseItemGuestStatus;
    amount: number;
    amounts?: Amounts;
    source: Source;
    waivers?: Waiver[];
    waiverUrl?: string;
    object: PurchaseItemObject.EXPERIENCE | PurchaseItemObject.ORDER | PurchaseItemObject.EQUIPMENT;
    tickets?: Ticket[];
    shortCode: string;
    recipientName: string;
    coupon?: Coupon;
    couponCode?: CouponCode;
    redeemed?: number;
    balance?: number;
    recognized?: number;
    deferred?: number;
    form?: Form;
    formResponse?: FormResponse;
    organizer: Organizer;
    expiresAt?: Dayjs;
    parentProductName?: string;
    parentProduct?: ProductReference;
    ticketCode?: string;
    _priceConfigurationUpdated?: boolean;
    totalGuestWeight: {
        value: number;
        unit: WeightUnit;
    };
    revenue?: number;
    partner?: { id: ID; object: PartnerObject };
    partnerSeller?: { id: ID };
    membershipPurchaseItem?: MembershipPurchaseItem | { id: ID };
    createdAt?: Dayjs;
    updatedAt?: Dayjs;
    seller?: { id: ID };
    pickupLocation?: string;
    reminders?: PurchaseItemReminder[];
    collectReview?: boolean;
    cancellationProtection?: CancellationProtection;
}

// TODO: There are already three privacy type enums defined
// We should probably only use one
export enum PurchaseItemPrivacy {
    PUBLIC = "public",
    PRIVATE = "private",
}
